export interface LocaleSurvey {
	description: string;
	cta: string;
	closeAriaLabel: string;
	href: string;
}

export type BVASurvey = {
	[key in 'fr']: LocaleSurvey;
} & {
	active: boolean;
	delay: number;
	maxNbOpenPerSession: number;
	sessionKey: string;
};

export const bvaSurvey: BVASurvey = {
	active: true,
	delay: 5000,
	maxNbOpenPerSession: 1,
	sessionKey: 'surveyNbOpen',
	fr: {
		description:
			'Répondez en quelques minutes à notre questionnaire pour nous permettre de mieux connaître vos attentes ! ',
		cta: 'Je réponds',
		closeAriaLabel: 'Fermer',
		href: 'https://surveys.hotjar.com/4c5e3f3d-e5fd-4a71-ae05-2e8872786d5a',
	},
};
